import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    color: var(--white);
  }
  html, body, #root {
    max-height: 100vh;
    max-width: 100vw;
    height: 100%;
    width: 100%;
  }
  *, button, input {
    border: 0;
    background: none;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;

  }
  html {
    background: var(--primary);
  }
  :root {
    
    --retweet: #00C06B;
    --like: #E8265E;


    --primary: #000;
    --secondary: #15181C;
    --search: #202327;
    --white: #D9D9D9;
    --gray: #7A7A7A;
    --outline: #2F3336;


    --twitter: ${props => props.theme.twitter};
    --twitter-dark-hover: ${props => props.theme.twitter_dark_hover};
    --twitter-light-hover: ${props => props.theme.twitter_light_hover};


    --blue: #1DA1F2;
    --yellow: #ffad1f;
    --pink: #e0245e;
    --purple: #794bc4;
    --orange: #f45d22;
    --green: #17bf63;

  }
`